// classes
import EventEmitter from "./EventEmitter"

export default class Sizes extends EventEmitter
{
    constructor()
    {
        // override
        super()

        // options
        this.width = innerWidth
        this.height = innerHeight
        this.aspectRatio = this.width / this.height
        this.pixelRatio = devicePixelRatio <= 2 ? devicePixelRatio : 2

        // on resize
        window.addEventListener( "resize", () => 
        {
            this.width = innerWidth
            this.height = innerHeight   
            this.aspectRatio = this.width / this.height
            this.pixelRatio = devicePixelRatio <= 2 ? devicePixelRatio : 2

            // emitt resize
            this.trigger( "resize" )
        } )
    }
}